import React from 'react'
import { AssignmentsCounter } from 'components/AssignmentsCounter'
import { GridItem, GridContainer } from 'components/Grid'

const Dashboard = () => (
  <GridContainer>
    <GridItem startCol={1} endCol={4}>
      <AssignmentsCounter />
    </GridItem>
  </GridContainer>
)

export { Dashboard }
